/** Form id — lets the footer's submit button live outside the `<form>`. */
export const RECEIVE_CONVOY_FORM_ID = 'receive-convoy-form';
